var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function getWebEncodedComponentData(target, key) {
  const strData = target.dataset[key];
  try {
    const decodedData = atob(strData);
    return JSON.parse(decodedData);
  } catch {
    return {};
  }
}

function createElementFromHTML(htmlString) {
  var div = document.createElement("div");
  div.innerHTML = htmlString.trim();

  // Change this to div.childNodes to support multiple top-level nodes.
  return div.firstChild;
}

function findVariantBySelectedOptionsExact(variants, values) {
  if (!Array.isArray(values) || !values.length) return null;

  return variants.find((variant) => {
    if (!Array.isArray(variant.options)) return false;
    if (variant.options.length !== values.length) return false;

    // Shopify options are ordered; match by index
    for (let i = 0; i < values.length; i++) {
      if (String(variant.options[i]) !== String(values[i])) return false;
    }
    return true;
  }) || null;
}

function findVariantByOptionValuesLooseColor(variants, values) {
  if (!Array.isArray(values) || !values.length) return null;

  const desiredColor = values.find(v =>
    variants.some(variant => variant.options.includes(v))
  );
  if (!desiredColor) return null;

  return variants.find(variant => variant.options.includes(desiredColor)) || null;
}

function paramsToObject() {
  const urlParams = new URLSearchParams(window.location.search);
  const entries = urlParams.entries();
  const result = {};
  for (const [key, value] of entries) {
    // each 'entry' is a [key, value] tupple
    result[key] = value;
  }
  return result;
}

function insertUrlParam(key, value, { replace = false } = {}) {
  const u = new URL(window.location.href);
  u.searchParams.set(key, value);

  // Keep existing hash (#...)
  const nextUrl = u.pathname + "?" + u.searchParams.toString() + u.hash;

  if (replace) {
    history.replaceState({ path: nextUrl }, "", nextUrl);
  } else {
    history.pushState({ path: nextUrl }, "", nextUrl);
  }
}

function findFirstIntersection(arr1, arr2) {
  for (let item1 of arr1) {
    if (arr2.includes(item1)) {
      return item1;
    }
  }
  return null; // Return null if there is no intersection
}

function watchPopStateChanges(callback) {
  window.addEventListener("popstate", callback);
}

class CartWorker extends HTMLElement {
  openCart() {
    document.querySelector(".flyout").classList.add("active");
    document.body.style.overflow = "hidden";
  }

  async addVariantToCart(id, quantity) {
    const formData = {
      items: [{ id: id, quantity: +quantity }],
    };

    const rawAddToCartResponse = await fetch(
      window.Shopify.routes.root + "cart/add.js",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      }
    );
    const addToCartResponse = await rawAddToCartResponse.json();

    [
      { id: "main-cart-items", selector: ".cart__items" },
      { id: "main-cart-footer", selector: ".cart__footer-inner" },
      { id: "header", selector: "#shopify-section-header" },
    ].forEach((group) => {
      fetch(`?section_id=${group.id}`)
        .then((resp) => resp.text())
        .then((state) => {
          document.querySelector(group.selector).innerHTML = state;
        });
    });

    this.openCart();
  }
}

class EducationModule extends CartWorker {
  connectedCallback() {
    this.querySelector("form").addEventListener("submit", async (e) => {
      e.preventDefault();

      const id = e.target.querySelector('[name="id"]');

      if (id) {
        this.addVariantToCart(id.value, 1);
      }
    });
  }
}

customElements.define("education-module", EducationModule);

class ProductHero extends CartWorker {
  connectedCallback() {
    this.swiper = null;
    this.swiperConfig = {
      loop: false,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
    };
    this.productTags = getWebEncodedComponentData(this, "productTags");
    this.productVariantsInfo = getWebEncodedComponentData(
      this,
      "productVariantsInfo"
    );
    this.selectedVariantId = getWebEncodedComponentData(
      this,
      "defaultVariantId"
    );
    this.variants = getWebEncodedComponentData(this, "variants");
    this.alternativeProducts = getWebEncodedComponentData(this, "alternativeProducts") || {};
    if (this.variants) {
      this.selectedVariant = this.variants.find(
        (variant) => variant.id === this.selectedVariantId
      );
    }

    // --- honor ?variant= on initial render ---
    try {
      const params = paramsToObject();
      const urlVariantId = params.variant ? params.variant : null;
      if (urlVariantId && Array.isArray(this.variants)) {
        const v = this.variants.find((vv) => String(vv.id) === String(urlVariantId));
        if (v) {
          this.selectedVariant = v;
          this.selectedVariantId = v.id;
        }
      }
    } catch (_) {}
    // --- end honor ?variant= ---

    // --- try to honor carried-over color from previous product-length swap ---
    let desiredColorFromSwap = this.dataset.desiredColor || null;

    // attempt to decode baseValues (the other option values like length/size)
    let baseValuesFromSwap = [];
    if (this.dataset.baseValuesB64) {
      try {
        baseValuesFromSwap = JSON.parse(atob(this.dataset.baseValuesB64));
      } catch (_) {
        baseValuesFromSwap = [];
      }
    }

    // If we have a desiredColorFromSwap, try to force that variant here
    if (desiredColorFromSwap && Array.isArray(this.variants) && this.variants.length) {
      const guessVals = [...baseValuesFromSwap, desiredColorFromSwap].filter(Boolean);

      // 1) exact match by option index
      let carriedVariant = findVariantBySelectedOptionsExact(this.variants, guessVals);

      // 2) fallback ONLY if we could not build an exact match (e.g. missing base values)
      if (!carriedVariant && (!Array.isArray(baseValuesFromSwap) || !baseValuesFromSwap.length)) {
        carriedVariant = this.variants.find((v) =>
          Array.isArray(v.options) && v.options.includes(desiredColorFromSwap)
        );
      }

      if (carriedVariant) {
        this.selectedVariant = carriedVariant;
        this.selectedVariantId = carriedVariant.id;
      }
    }


    this.sharedMedia = { all: [], blonde: [], brunette: [], red: [] };

    try {
      const sharedEl = this.querySelector("[data-shared-media]");
      if (sharedEl && sharedEl.textContent) {
        const parsed = JSON.parse(sharedEl.textContent);

        // parsed is now an object keyed by group
        this.sharedMedia = {
          all: Array.isArray(parsed?.all) ? parsed.all : [],
          blonde: Array.isArray(parsed?.blonde) ? parsed.blonde : [],
          brunette: Array.isArray(parsed?.brunette) ? parsed.brunette : [],
          red: Array.isArray(parsed?.red) ? parsed.red : [],
        };
      }
    } catch (_) {
      this.sharedMedia = { all: [], blonde: [], brunette: [], red: [] };
    }

    this.currentColorGroup = "all";
    this.updateProductImages();

    this.initCarousel();
    this.initProductForm();



    this.updateFormUI();
    this.updateColorPickerSelectedOption();

    watchPopStateChanges(this.handlePopNavigation.bind(this));
  }

  // End of Connected Callback

syncAlternativeProductLinkForVariant(variant) {
  const container = this.querySelector(".variant-alternative-link-js");
  const message = this.querySelector(".variant-alternative-link-message-js");

  if (!container || !message || !variant) {
    if (container) container.hidden = true;
    return;
  }

  // hide if current variant is available
  if (variant.available) {
    container.hidden = true;
    return;
  }

  // associated product data missing
  if (
    !this.alternativeProducts ||
    !Array.isArray(this.alternativeProducts.variants)
  ) {
    container.hidden = true;
    return;
  }

  // try to match by exact title first
  let matchedVariant = this.alternativeProducts.variants.find((v) => {
    return (
      v.title === variant.title &&
      v.available
    );
  });

  // fallback: exact ordered options match
  if (!matchedVariant && Array.isArray(variant.options)) {
    matchedVariant = this.alternativeProducts.variants.find((v) => {
      if (!v.available || !Array.isArray(v.options)) return false;

      return JSON.stringify(v.options) === JSON.stringify(variant.options);
    });
  }

  // no matching available variant
  if (!matchedVariant) {
    container.hidden = true;
    return;
  }

  const targetUrl = `${this.alternativeProducts.targetUrl}?variant=${matchedVariant.id}`;

  const debugMessage = `
  This shade is available in
  ${this.alternativeProducts.targetHandle}
  (${matchedVariant.title})
  ${targetUrl}
`;

console.log(debugMessage);

  message.innerHTML = `
    Need this shade sooner?
    <a href="${targetUrl}" class="underline font-semibold">
      Try The Volume Elite Weft
    </a>
    for faster installs and fuller transformations.
  `;

  container.hidden = false;
}

  handlePopNavigation() {
    const params = paramsToObject();
    const newVariantId = params.variant;
    this.selectedVariant =
      this.variants.find((variant) => String(variant.id) === String(newVariantId)) ||
      this.variants[0];
    this.updateFormUI();
    this.updateColorPickerSelectedOption();
    this.syncPurchaseButtonsForVariant(this.selectedVariant);

  }

  initProductForm() {
    const isCustomColorSizePicker = this.productTags.includes(
      "custom-color-size-picker"
    );

    this.addSimilarProductNavigation();
    if (isCustomColorSizePicker) {
      this.addColorPickerOptionChangeEvents();
    } else {
      this.addDefaultOptionChangeEvents();
    }

    // ATC BUTTON EVENT
    const atcButton = this.querySelector("#add-to-cart-js");
    atcButton.addEventListener("click", () => {
      const quantity = this.querySelector("#quantity-js");
      if (quantity)
        this.addVariantToCart(this.selectedVariant.id, quantity.value);
    });
  }

Buttons() {
  const container = this.querySelector("[data-length-buttons]");
  if (!container) return;

  // Parse Liquid-fed JSON (base64)
  let choices = [];
  try {
    const b64 = container.dataset.lengthJsonB64 || "";
    if (b64) choices = JSON.parse(atob(b64));
  } catch (_) {
    choices = [];
  }
  if (!choices.length) return;

  // numeric sort by inches (if present)
  const toNum = (label) => {
    const m = String(label).match(/([\d.]+)/);
    return m ? parseFloat(m[1]) : 0;
  };
  choices.sort((a, b) => toNum(a.label) - toNum(b.label));

  // Layout: equal-width grid columns
  const count = choices.length;
  container.className = "length-button-group grid gap-2";
  container.style.gridTemplateColumns = `repeat(${count}, minmax(0, 1fr))`;

  // Render buttons
  container.innerHTML = "";
  choices.forEach((c) => {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.textContent = c.label;
    btn.dataset.url = c.url || "";
    btn.className = [
      "length-choice-btn",
      "w-full", "px-3", "py-2",
      "rounded-xl", "border", "border-blk",
      "text-sm", "text-center",
      c.selected ? "bg-black text-white color-white aileron-black" : "bg-white text-black color-black"
    ].join(" ");
    btn.setAttribute("aria-pressed", c.selected ? "true" : "false");
    container.appendChild(btn);
  });

  // Set active visual and label
  const setActive = (btnEl) => {
    container.querySelectorAll(".length-choice-btn").forEach((b) => {
      b.classList.remove("bg-black", "text-white", "color-white", "aileron-black");
      b.classList.add("bg-white", "text-black", "color-black");
      b.setAttribute("aria-pressed", "false");
    });
    btnEl.classList.remove("bg-white", "text-black", "color-black");
    btnEl.classList.add("bg-black", "text-white", "color-white", "aileron-black");
    btnEl.setAttribute("aria-pressed", "true");

    const labelEl = this.querySelector(".selected-length-label-js");
    if (labelEl) labelEl.textContent = btnEl.textContent;
  };

  // pick initially selected (or first)
  const initiallySelected =
    container.querySelector(".length-choice-btn[aria-pressed='true']") ||
    container.querySelector(".length-choice-btn");
  if (initiallySelected) setActive(initiallySelected);

  // fetch & swap logic (keeps same behavior as other parts of this class)
  const fetchAndSwap = async (targetUrl) => {
    let swapped = false;
    try {
      const optionSelectEls = this.getOptionSelectEls ? this.getOptionSelectEls() : [];
      const baseValuesCurrent = optionSelectEls.map((el) => el.value);

      // current selected color in this hero (if any)
      const selectedColorBtn = this.querySelector(".color-picker-option-js.js-selected-option");
      const currentColor = selectedColorBtn ? selectedColorBtn.dataset.option : null;

      const resp = await fetch(`${targetUrl}?view=ajax-hero`, { credentials: "same-origin" });
      if (!resp.ok) throw new Error("Bad response");
      const html = await resp.text();

      const tmp = document.createElement("div");
      tmp.innerHTML = html.trim();
      const newHero = tmp.querySelector("product-hero");
      if (!newHero) throw new Error("No <product-hero> found in ajax view");

      const newVariants = getWebEncodedComponentData(newHero, "variants") || [];

      // determine desired color to preserve (if present and visible on incoming hero)
      const newButtons = Array.from(newHero.querySelectorAll(".color-picker-option-js"));
      const hasCurrentColor = currentColor
        ? newButtons.some((b) => b.getAttribute("data-option") === currentColor && !b.classList.contains("hidden"))
        : false;
      const desiredColor = hasCurrentColor
        ? currentColor
        : (newHero.querySelector(".color-picker-option-js.js-selected-option")?.getAttribute("data-option") || null);

      const baseValuesIncoming = Array.from(newHero.querySelectorAll(".select-option-js")).map((el) => el.value);
      const baseValues = baseValuesIncoming.length ? baseValuesIncoming : baseValuesCurrent;

      // pick a best-fit variant
      let targetVariant = null;
      if (newVariants.length) {
        if (desiredColor) {
          const exact = [...baseValues, desiredColor];
          // try strict index-matching first
          targetVariant = findVariantBySelectedOptionsExact(newVariants, exact);

          // only allow loose color-only fallback when we couldn't build base values
          if (!targetVariant && (!Array.isArray(baseValues) || !baseValues.length)) {
            targetVariant = newVariants.find((v) => Array.isArray(v.options) && v.options.includes(desiredColor));
          }
        }
        if (!targetVariant) targetVariant = newVariants.find((v) => v.available) || newVariants[0];
      }

      // inject context so new hero can honor carried color/base-values
      if (targetVariant) newHero.dataset.defaultVariantId = btoa(JSON.stringify(targetVariant.id));
      if (desiredColor) newHero.dataset.desiredColor = desiredColor;
      if (baseValues && baseValues.length) newHero.dataset.baseValuesB64 = btoa(JSON.stringify(baseValues));

      // swap DOM (triggers newHero.connectedCallback)
      this.replaceWith(newHero);
      swapped = true;

      // optional hook if present in page
      if (typeof updateAboutSection === "function") {
        await updateAboutSection(targetUrl);
      }

      // push history with picked variant
      const urlForHistory = targetVariant
        ? `${targetUrl}?variant=${encodeURIComponent(targetVariant.id)}`
        : targetUrl;
      history.pushState({ swapped: true }, "", urlForHistory);

      if (typeof newHero.refreshBackInStockWidget === "function") {
        newHero.refreshBackInStockWidget();
      }

    } catch (e) {
      console.error("fetchAndSwap failed:", e);
      if (!swapped) window.location.href = targetUrl;
    }
  };

  // guard against multiple wiring
  if (container.dataset.lengthBound === "1") return;
  container.dataset.lengthBound = "1";

  container.addEventListener("click", (ev) => {
    const btn = ev.target.closest(".length-choice-btn");
    if (!btn) return;

    setActive(btn);
    const url = btn.dataset.url;
    if (!url) return; // no swap needed for current length
    fetchAndSwap(url);
  });
}

addSimilarProductNavigation() {
  // Read data from Liquid
  let choices = [];
  try {
    const raw = this.dataset.lengthChoices ? atob(this.dataset.lengthChoices) : "[]";
    choices = JSON.parse(raw);
  } catch (_) { choices = []; }
  if (!choices.length) return;

  const container = this.querySelector("[data-length-buttons]");
  if (!container) return;

  // --- ensure grid layout ---
  container.classList.add("grid","gap-2"); // ADD
  const count = choices.length;
  container.style.gridTemplateColumns = `repeat(${count}, minmax(0, 1fr))`;

  // Sort by numeric inches (e.g., "18\"" -> 18)
  const toNum = (label) => {
    const m = String(label).match(/([\d.]+)/);
    return m ? parseFloat(m[1]) : 0;
  };
  const sorted = choices.slice().sort((a, b) => toNum(a.label) - toNum(b.label));

  // Render
  container.innerHTML = "";
  sorted.forEach((c) => {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.textContent = c.label;
    btn.dataset.url = c.url || "";
    btn.className = [
      "length-choice-btn",
      "w-full", "px-3", "py-2", "rounded-xl",
      "border", "border-blk", "text-sm", "text-center",
      c.selected ? "bg-black font-aileron-black color-hite text-white" : "bg-white text-black color-black"
    ].join(" ");
    btn.setAttribute("aria-pressed", c.selected ? "true" : "false"); // ADD
    container.appendChild(btn);
  });

  // Update active UI + small label above
  const setActive = (btnEl) => {
    container.querySelectorAll(".length-choice-btn").forEach((b) => {
      b.classList.remove("bg-black", "text-white", "color-white", "aileron-black");
      b.classList.add("bg-white", "text-black", "color-black");
    });
    btnEl.classList.add("bg-black", "text-white", "color-white");
    btnEl.classList.remove("bg-white", "text-black", "color-black");
    const labelEl = this.querySelector(".selected-length-label-js");
    if (labelEl) labelEl.textContent = btnEl.textContent;
  };

  // INIT: pick the selected (or first) and sync UI
  const initiallySelected =
    container.querySelector(".length-choice-btn[aria-pressed='true']") ||
    container.querySelector(".length-choice-btn");
  if (initiallySelected) setActive(initiallySelected); // ADD

  // Reuse your existing fetch/swap logic (kept intact)
  const fetchAndSwap = async (targetUrl) => {
    try {
      const optionSelectEls = this.getOptionSelectEls ? this.getOptionSelectEls() : [];
      const baseValuesCurrent = optionSelectEls.map((el) => el.value);

      const selectedColorBtn = this.querySelector(".color-picker-option-js.js-selected-option");
      const currentColor = selectedColorBtn ? selectedColorBtn.dataset.option : null;

      const resp = await fetch(`${targetUrl}?view=ajax-hero`, { credentials: "same-origin" });
      if (!resp.ok) throw new Error("Bad response");
      const html = await resp.text();

      const tmp = document.createElement("div");
      tmp.innerHTML = html.trim();
      const newHero = tmp.querySelector("product-hero");
      if (!newHero) throw new Error("No <product-hero> found in ajax view");

      const newVariants = getWebEncodedComponentData(newHero, "variants") || [];

      // Prefer same color if it exists AND is shown on the new product
      const newButtons = Array.from(newHero.querySelectorAll(".color-picker-option-js"));
      const hasCurrentColor = currentColor
        ? newButtons.some((b) => b.getAttribute("data-option") === currentColor && !b.classList.contains("hidden"))
        : false;
      const desiredColor = hasCurrentColor
        ? currentColor
        : (newHero.querySelector(".color-picker-option-js.js-selected-option")?.getAttribute("data-option") || null);

      const baseValuesIncoming = Array.from(newHero.querySelectorAll(".select-option-js")).map((el) => el.value);
      const baseValues = baseValuesIncoming.length ? baseValuesIncoming : baseValuesCurrent;

      let targetVariant = null;
      if (newVariants.length) {
        if (desiredColor) {
          const exact = [...baseValues, desiredColor];
          targetVariant =
            findVariantBySelectedOptionsExact(newVariants, exact) ||
            newVariants.find((v) => v.options.includes(desiredColor));
        }
        if (!targetVariant) targetVariant = newVariants.find((v) => v.available) || newVariants[0];
      }

      if (targetVariant) {
        newHero.dataset.defaultVariantId = btoa(JSON.stringify(targetVariant.id));
      }

      // Swap in the new hero
      this.replaceWith(newHero);

      // Sync URL
      const urlForHistory = targetVariant
        ? `${targetUrl}?variant=${encodeURIComponent(targetVariant.id)}`
        : targetUrl;
      history.pushState({ swapped: true }, "", urlForHistory);
    } catch (_) {
      window.location.href = targetUrl;
    }
  };
  if (container.dataset.lengthBound === "1") return;
  container.dataset.lengthBound = "1";

  // Wire click handlers
  container.addEventListener("click", (ev) => {
    const btn = ev.target.closest(".length-choice-btn");
    if (!btn) return;

    // If this is the “current” length (no URL), just update the selected UI and bail
    const url = btn.dataset.url;
    setActive(btn);
    if (!url) return;

    fetchAndSwap(url);
  });
}




  addDefaultOptionChangeEvents() {
    const optionSelectEls = this.getOptionSelectEls();

    for (const optionSelectEl of optionSelectEls) {
      optionSelectEl.addEventListener("change", () => {
        const optionSelectEls = this.getOptionSelectEls();
        const values = optionSelectEls.map((el) => el.value);

        const newSelectedVariant = findVariantBySelectedOptionsExact(this.variants, values);
        if (!newSelectedVariant) return;

        const soldOutButton = this.querySelector(".sold-out");
        const atcButton = this.querySelector(".add-to-cart");

        if (!newSelectedVariant.available) {
          atcButton.classList.add("hidden");
          soldOutButton.classList.remove("hidden");

        } else {
          atcButton.classList.remove("hidden");
          soldOutButton.classList.add("hidden");

        }

        this.selectedVariant = newSelectedVariant;
        this.updateFormUI();

        insertUrlParam("variant", newSelectedVariant.id, { replace: true });
      });
    }
  }


  addColorPickerOptionChangeEvents() {
    // Add Variant Option Selector Events
    const optionSelectEls = this.getOptionSelectEls();
    for (const optionSelectEl of optionSelectEls) {
      optionSelectEl.addEventListener("change", () => {
        const optionSelectEls = this.getOptionSelectEls();
        const rawValues = optionSelectEls.map((el) => el.value);

        const selectedColorButton = this.querySelector(".js-selected-option");
        if (!selectedColorButton) return;

        // --- set gallery group from the currently-selected color button ---
        {
          const kindRaw = selectedColorButton.dataset.kind || "";
          let group = "all";
          if (kindRaw.includes("blonde")) group = "blonde";
          else if (kindRaw.includes("brunette")) group = "brunette";
          else if (kindRaw.includes("red")) group = "red";
          this.currentColorGroup = group;
        }
        // --- end set gallery group ---

        const selectedColorValue = selectedColorButton.dataset.option;
        if (!selectedColorValue) return;
        const values = [...rawValues, selectedColorValue];

        const newSelectedVariant = findVariantBySelectedOptionsExact(this.variants, values);
        if (!newSelectedVariant) return;

        this.selectedVariant = newSelectedVariant;
        this.updateFormUI();

        insertUrlParam("variant", newSelectedVariant.id, { replace: true });
      });
    }



    // Add ColorKind Filter Events
    // cache once
    const colorKindTabButtons = Array.from(
      this.querySelectorAll(".pdp__colorkind-tab")
    );

    // helper that updates tab visuals
    const setTabStates = (mode, activeKind) => {
      // mode can be "all-active" or "single-active"
      colorKindTabButtons.forEach((btn) => {
        const isActive =
          mode === "all-active" || btn.dataset.value === activeKind;

        // reset both state classes first
        btn.classList.remove("color-tab--active", "color-tab--inactive");

        if (isActive) {
          btn.classList.add("color-tab--active");   // white bg look
        } else {
          btn.classList.add("color-tab--inactive"); // black bg look
        }
      });
    };

    const applyFilterForKind = (kindOrNull) => {
      const colorPickerButtons = Array.from(
        this.querySelectorAll(".color-picker-option-js")
      );

      if (!kindOrNull) {
        // NO FILTER:
        // 1. Show every swatch
        colorPickerButtons.forEach((btn) => btn.classList.remove("hidden"));

        // 2. Make ALL tabs look active (white)
        setTabStates("reset", null);

        this.colorKind = null;
        return;
      }

      // WITH FILTER:
      // 1. Only show matching swatches
      colorPickerButtons.forEach((btn) => {
        const btnKinds = btn.dataset.kind || "";
        if (btnKinds.includes(kindOrNull)) {
          btn.classList.remove("hidden");
        } else {
          btn.classList.add("hidden");
        }
      });

      // 2. Style just that tab as active (white), others inactive (black)
      setTabStates("single-active", kindOrNull);

      this.colorKind = kindOrNull;
    };

    // attach click listeners
    for (const tabBtn of colorKindTabButtons) {
      tabBtn.addEventListener("click", () => {
        const clickedKind = tabBtn.dataset.value;

        if (this.colorKind === clickedKind) {
          // clicking same tab again clears filter
          applyFilterForKind(null);
        } else {
          applyFilterForKind(clickedKind);
        }
      });
    }

    // on first load, default should be "no filter" state:
    applyFilterForKind(null);


    // Add Color Picker Events
    const colorPickerButtonEls = Array.from(
      this.querySelectorAll(".color-picker-option-js")
    );

    for (const colorPickerButton of colorPickerButtonEls) {
      colorPickerButton.addEventListener("click", () => {
        // --- set gallery group from the clicked swatch ---
        {
          const kindRaw = colorPickerButton.dataset.kind || "";
          let group = "all";
          if (kindRaw.includes("blonde")) group = "blonde";
          else if (kindRaw.includes("brunette")) group = "brunette";
          else if (kindRaw.includes("red")) group = "red";
          this.currentColorGroup = group;
        }
        // --- end set gallery group ---
        const optionSelectEls = this.getOptionSelectEls();
        const rawValues = optionSelectEls.map((el) => el.value);
        const values = [...rawValues, colorPickerButton.dataset.option];

        const newSelectedVariant = findVariantBySelectedOptionsExact(this.variants, values);
        if (!newSelectedVariant) return;

        const soldOutButton = this.querySelector(".sold-out");
        const atcButton = this.querySelector(".add-to-cart");

        if (!newSelectedVariant.available) {
          atcButton.classList.add("hidden");
          soldOutButton.classList.remove("hidden");
        } else {
          atcButton.classList.remove("hidden");
          soldOutButton.classList.add("hidden");
        }

        this.selectedVariant = newSelectedVariant;
        this.updateFormUI();
        this.updateColorPickerSelectedOption();

        insertUrlParam("variant", newSelectedVariant.id);
      });
    }
  }

  getOptionSelectEls() {
    return Array.from(this.querySelectorAll(".select-option-js"));
  }

  updateFormUI() {
    this.updateSelectedOptionsLabels();
    this.updateSelectedOptions();
    this.updatePrices();
    this.updateShopPay();
    this.updateCarouselImages();
    this.syncPurchaseButtonsForVariant(this.selectedVariant);
    this.refreshBackInStockWidget()

    const lowStockBadge = this.querySelector(".selected-color-low-stock-js");
    const variantInfo = this.productVariantsInfo?.[this.selectedVariant?.id];

    if (lowStockBadge) {
      const qty = Number(variantInfo?.inventoryQuantity || 0);
      const isLowStock = qty > 0 && qty <= 10;

      lowStockBadge.textContent = isLowStock ? `Only ${qty} left!` : "";
      lowStockBadge.classList.toggle("hidden", !isLowStock);
    }
  }

  syncPurchaseButtonsForVariant(variant) {
    const soldOutButton = this.querySelector(".sold-out");
    const atcButton = this.querySelector(".add-to-cart");
    if (!soldOutButton || !atcButton) return;

    if (!variant.available) {
      // show Sold Out
      atcButton.classList.add("hidden");
      soldOutButton.classList.remove("hidden");
    } else {
      // show Add to Cart
      atcButton.classList.remove("hidden");
      soldOutButton.classList.add("hidden");
    }
    this.syncAlternativeProductLinkForVariant(variant);
  }

  refreshBackInStockWidget() {
    return;
    if (!window.SI || typeof window.SI.createPopover !== "function") return;

    try {
      // remove old Appikon button
      const oldWidget = document.querySelector(".si-reset");
      if (oldWidget) oldWidget.remove();

      // remove old Appikon iframe popup
      const oldFrame = document.querySelector("#SI_frame");
      if (oldFrame) oldFrame.remove();

      // Recreate widget for the CURRENT product. Prefer explicit product handle attribute if present.
      const productHandleFromAttr = this.dataset.productHandle || this.getAttribute('data-product-handle');
      let productHandle = productHandleFromAttr || null;
      if (!productHandle) {
        const productUrl = this.dataset.productUrl || this.getAttribute('data-product-url') || window.location.pathname;
        try {
          const m = String(productUrl).match(/\/products\/([^\/\?#]+)/);
          if (m) productHandle = decodeURIComponent(m[1]);
        } catch (_) {
          productHandle = null;
        }
      }

      if (productHandle && window.SI && typeof window.SI.createPopover === 'function') {
        window.SIPopover = window.SI.createPopover({ productHandle: productHandle });
      } else {
        // fallback to library default
        window.SIPopover = window.SI.createPopover();
      }
      window.SI.popup = window.SIPopover;

      // sync current selected variant into the new popover button
      if (this.selectedVariant && window.SIPopover && typeof window.SIPopover.toggleForVariant === "function") {
        window.SIPopover.toggleForVariant(this.selectedVariant.id);
      }
    } catch (e) {
      console.error("BIS refresh failed:", e);
    }
  }


  updateSelectedOptions() {
    const optionSelectEls = this.getOptionSelectEls();

    for (const optionSelectElIndex in optionSelectEls) {
      const optionSelectEl = optionSelectEls[optionSelectElIndex];
      const selectVals = getWebEncodedComponentData(optionSelectEl, 'values');
      if (selectVals) {
        const selectedVariantOptions = this.selectedVariant["options"];
        const newValue = findFirstIntersection(
          selectedVariantOptions,
          selectVals
        );
        optionSelectEl.value = newValue;
      }
    }
  }

  updateSelectedOptionsLabels() {
    // change field label
    const optionLabelEls = Array.from(
      this.querySelectorAll(".selected-option-label-js")
    );

    for (const optionLabelEl of optionLabelEls) {
      const optionKey = optionLabelEl.dataset.optionKey;
      if (optionKey) {
        const newLabel = this.selectedVariant[optionKey];
        optionLabelEl.innerHTML = newLabel;
      }
    }
  }

  updatePrices() {
    // change pdp-hero-prices
    const variantPrice = this.selectedVariant.price;
    const variantPriceStr = Shopify.formatMoney(variantPrice, "${{ amount }}");
    const priceTargets = Array.from(this.querySelectorAll(".price-target-js"));

    const variantComparePrice = this.selectedVariant.compare_at_price;
    const variantComparePriceStr = Shopify.formatMoney(variantComparePrice, "${{ amount }}");
    const comparePriceTargets = Array.from(this.querySelectorAll(".compare-at-price-target-js"));

    for (const priceTargetEl of priceTargets) {
      priceTargetEl.innerHTML = variantPriceStr;
    }

    for (const comparePriceTargetEl of comparePriceTargets) {
      if (variantComparePrice && variantComparePrice > variantPrice) {
        comparePriceTargetEl.innerHTML = variantComparePriceStr;
      } else {
        comparePriceTargetEl.innerHTML = "";
      }
    }
  }

  updateShopPay() {
    const target = this.querySelector(".shoppay-target-js");
    target.innerHTML = `
      <shop-pay-button
        class="block col-span-12 lg:col-span-8 xl:col-span-9 border border-black rounded-xl overflow-hidden"
        store-url="https://harper-ellis-hair-co.myshopify.com"
        variants="${this.selectedVariant.id}"
      ></shop-pay-button>
      `;
  }

  updateColorPickerSelectedOption() {
    const colorDescriptionContainer = document.querySelector(
      ".color-description-container-js"
    );

    const colorMessageContainer = document.querySelector(
      ".color-message-container-js"
    );

    const colorPickerButtonEls = Array.from(
      this.querySelectorAll(".color-picker-option-js")
    );

    const optionLabelEl = this.querySelector(".selected-color-label-js");

    for (const colorPickerButton of colorPickerButtonEls) {
      const option = colorPickerButton.dataset.option;
      if (this.selectedVariant.options.includes(option)) {
        colorPickerButton.classList.add("js-selected-option");
        colorPickerButton.classList.add("bg-white");
        colorPickerButton.classList.add("border");
        optionLabelEl.innerHTML = option;
      } else {
        colorPickerButton.classList.remove("js-selected-option");
        colorPickerButton.classList.remove("bg-white");
        colorPickerButton.classList.remove("border");
      }
    }

    if (
      this.productVariantsInfo[this.selectedVariant.id].colorDescription != null
    ) {
      colorDescriptionContainer.innerHTML =
        this.productVariantsInfo[this.selectedVariant.id].colorDescription;
      colorDescriptionContainer.classList.add("block");
      colorDescriptionContainer.classList.remove("hidden");
    } else {
      colorDescriptionContainer.classList.add("hidden");
      colorDescriptionContainer.classList.remove("block");
      colorDescriptionContainer.innerHTML = "";
    }

    // ---- HARD CODED VARIANT IDS ----
    const messageVariantIds = [
      44529752834274,
      44529753358562,
      44529753817314,
      44529753915618,
      44529770037474,
      44529770037474,
      44529771020514,
      44529771118818,
      44529799397602,
      44529799921890,
      44529800380642,
      44529800478946
    ];
    const cutoff = new Date("2025-12-06T05:59:00Z"); 

    const now = new Date();
    if (now > cutoff) {
      colorMessageContainer.classList.add("hidden");
      colorMessageContainer.classList.remove("block");
      colorMessageContainer.innerHTML = "";
      return; // stop here, do not evaluate further
    }

    // Otherwise continue with variant ID check
    if (messageVariantIds.includes(Number(this.selectedVariant.id))) {
      colorMessageContainer.innerHTML =
        '<strong>Select Elite Weft Shades in 18", 22" and 24" are not eligible for the BFCM discount:</strong> The Amanda, The Chocolate, The Creighton, or The Cali. Excluded products <strong>do not</strong> count toward the cart total required to unlock percentage-off savings.';

      colorMessageContainer.classList.add("block");
      colorMessageContainer.classList.remove("hidden");
    } else {
      colorMessageContainer.classList.add("hidden");
      colorMessageContainer.classList.remove("block");
      colorMessageContainer.innerHTML = "";
    }

  }

  getSelectedColorGroup() {
    const selected = this.querySelector(".color-picker-option-js.js-selected-option");
    if (!selected) return null;

    const kind = (selected.dataset.kind || "").toLowerCase();

    if (kind.includes("blonde")) return "blonde";
    if (kind.includes("brunette")) return "brunette";
    if (kind.includes("red")) return "red";

    return null; // fallback → use "all"
  }


  updateCarouselImages() {
    this.swiper.destroy();
    this.swiper = null;
    this.updateProductImages();
    this.initCarousel();
  }

  updateProductImages() {
    // 1) Base images (existing behavior)
    const variantArr = this.productVariantsInfo[this.selectedVariant.id];

    let baseImages = [];
    if (!variantArr) {
      baseImages = this.productVariantsInfo.default
        ? this.productVariantsInfo.default.images.slice(0, 8)
        : [];
    } else {
      baseImages = variantArr.images && variantArr.images.length
        ? variantArr.images
        : (this.productVariantsInfo.default
            ? this.productVariantsInfo.default.images.slice(0, 8)
            : []);
    }

    const group = this.currentColorGroup || "all";
    const shared = this.sharedMedia?.[group] || this.sharedMedia?.all || [];

    this.productImages = [...baseImages, ...shared];
  }

initCarousel() {
  const target = this.querySelector(".gallery-target");
  if (!target) return;

  // Clear whatever was there before
  target.innerHTML = "";

  //
  // <div class="relative w-full">
  //
  const outer = document.createElement("div");
  outer.className = "relative w-full";

  //
  // <div class="relative swiper pdp-hero-swiper w-full">
  //
  const swiperShell = document.createElement("div");
  swiperShell.className = "relative swiper pdp-hero-swiper w-full";

  //
  // <div class="swiper-wrapper"></div>
  //
  const wrapper = document.createElement("div");
  wrapper.className = "swiper-wrapper";
  swiperShell.appendChild(wrapper);

  // Prev arrow button
  const prevBtn = document.createElement("button");
  prevBtn.className = [
    "pdp-swiper-prev",
    "pdp-swiper-arrow",
    "pdp-swiper-arrow-prev", 
    "absolute", "top-1/2", "-translate-y-1/2",
    "left-2",
    "z-20",
    "w-10", "h-10",            // clickable area ~40px
    "flex", "items-center", "justify-center",
    "bg-transparent", "border-0", "p-0", "cursor-pointer",
    "text-black"              // so SVG inherits black via currentColor
  ].join(" ");
  prevBtn.setAttribute("aria-label", "Previous image");

  // same chevron but flipped via CSS
  prevBtn.innerHTML = `
    <svg
      class="pdp-arrow-svg pdp-arrow-svg-prev block"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
    >
      <path fill-rule="evenodd"
        d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
      />
    </svg>
  `;
  swiperShell.appendChild(prevBtn);

  // Next arrow button
  const nextBtn = document.createElement("button");
  nextBtn.className = [
    "pdp-swiper-next",
    "pdp-swiper-arrow",
    "pdp-swiper-arrow-next",   
    "absolute", "top-1/2", "-translate-y-1/2",
    "right-2",
    "z-20",
    "w-10", "h-10",
    "flex", "items-center", "justify-center",
    "bg-transparent", "border-0", "p-0", "cursor-pointer",
    "text-black"
  ].join(" ");
  nextBtn.setAttribute("aria-label", "Next image");

  // same chevron, not flipped
  nextBtn.innerHTML = `
    <svg
      class="pdp-arrow-svg pdp-arrow-svg-next block"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
    >
      <path fill-rule="evenodd"
        d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
      />
    </svg>
  `;
  swiperShell.appendChild(nextBtn);

  //
  // Thumbnail strip
  // <div class="pdp-thumb-strip flex gap-2 mt-4 overflow-x-auto"></div>
  //
  const thumbStrip = document.createElement("div");
  thumbStrip.className = "pdp-thumb-strip flex gap-2 mt-4 overflow-x-auto";

  //
  // Assemble:
  // outer
  //   ├─ swiperShell
  //   └─ thumbStrip
  //
  outer.appendChild(swiperShell);
  outer.appendChild(thumbStrip);

  //
  // Drop into the DOM
  //
  target.appendChild(outer);

  //
  // Fill slides + thumbs
  //
  this.renderImages();   // this assumes renderImages() finds ".swiper-wrapper"
  this.renderThumbs();   // ...and renderThumbs() finds ".pdp-thumb-strip"

  //
  // Init Swiper and wire thumbs/arrows
  //
  if (this.swiperConfig) {
    this.swiper = new Swiper(".swiper.pdp-hero-swiper", this.swiperConfig);

    this.configureThumbs();
    this.configureArrows();
  }
}

renderImages() {
  const items = this.productImages || [];
  const target = this.querySelector(".gallery-target .swiper-wrapper");
  if (!target) return;

  // Gate: ONLY use new mixed-media rendering if the new template injected shared media JSON
  const hasNewTemplate = !!this.querySelector('script[data-shared-media]');

  target.innerHTML = "";

  // LEGACY PATH (old template): render only images using the old markup
  if (!hasNewTemplate) {
    for (const image of items) {
      // Defensive: ignore non-images in legacy mode
      if (image && image.type === "video") continue;

      const swiperSlide = createElementFromHTML(`
        <div class="relative swiper-slide" style="padding-bottom: 90%;">
          <site-image>
            <div class="mediabox">
              <img
                src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                alt="${image?.alt || ""}"
                height="${image?.height || ""}"
                width="${image?.width || ""}"
                class="lazyload slide-image ${image?.additionalClass || ""}"
                data-lowsrc="${image?.src375 || ""}"
                data-sizes="${image?.sizes || "auto"}"
                data-srcset="${image?.src375 || ""} 375w, ${image?.src550 || ""} 550w, ${image?.src750 || ""} 750w, ${image?.src1100 || ""} 1100w, ${image?.src1500 || ""} 1500w, ${image?.src1780 || ""} 1780w"
              />
            </div>
          </site-image>
        </div>
      `);

      target.appendChild(swiperSlide);
    }
    return;
  }

  // NEW PATH (new template): allow images + videos and use pdp-media-frame wrapper
  for (const item of items) {
    const isVideo = item?.type === "video";

    const mediaHtml = isVideo
      ? `
        <video
          playsinline
          muted
          autoplay
          loop
          preload="metadata"
          ${item?.poster ? `poster="${item.poster}"` : ""}
        >
          <source src="${item?.src || ""}" type="video/mp4" />
        </video>
      `
      : `
        <site-image>
          <div class="mediabox">
            <img
              src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
              alt="${item?.alt || ""}"
              height="${item?.height || ""}"
              width="${item?.width || ""}"
              class="lazyload slide-image ${item?.additionalClass || ""}"
              data-lowsrc="${item?.src375 || ""}"
              data-sizes="${item?.sizes || "auto"}"
              data-srcset="${item?.src375 || ""} 375w, ${item?.src550 || ""} 550w, ${item?.src750 || ""} 750w, ${item?.src1100 || ""} 1100w, ${item?.src1500 || ""} 1500w, ${item?.src1780 || ""} 1780w"
            />
          </div>
        </site-image>
      `;

    const swiperSlide = createElementFromHTML(`
      <div class="relative swiper-slide">
        <div class="pdp-media-frame">
          ${mediaHtml}
        </div>
      </div>
    `);

    target.appendChild(swiperSlide);
  }
}



renderThumbs() {
  const media = this.productImages || [];
  const strip = this.querySelector(".pdp-thumb-strip");
  if (!strip) return;

  // Gate: ONLY change thumbnails when the new template is active
  const hasNewTemplate = !!this.querySelector('script[data-shared-media]');

  strip.innerHTML = "";

  // Ensure strip class baseline (initCarousel sets flex+overflow classes)
  // We'll only swap layout classes for the new template.
  if (!hasNewTemplate) {
    // ----- LEGACY (UNCHANGED): horizontal strip -----
    strip.className = "pdp-thumb-strip flex gap-2 mt-4 overflow-x-auto";

    media.forEach((item, i) => {
      const thumbBtn = document.createElement("button");
      thumbBtn.type = "button";
      thumbBtn.className = [
        "pdp-thumb-btn",
        "relative",
        "w-[60px] h-[60px]",
        "flex-shrink-0",
        "overflow-hidden",
        "rounded-xl",
        "border",
        "border-dark",
        "bg-white",
        "p-0"
      ].join(" ");
      thumbBtn.dataset.index = i;

      if (!item || item.type === "image" || !item.type) {
        const src = item?.src375 ?? "";
        const alt = item?.alt ?? "";
        thumbBtn.innerHTML = `
          <img src="${src}" alt="${alt}" class="object-cover object-center w-full h-full block" />
          <span class="pdp-thumb-active-indicator pointer-events-none absolute inset-0 rounded-xl border-2 border-transparent"></span>
        `;
      } else if (item.type === "video") {
        const poster = item.poster || "";
        const alt = item.alt || "Video";
        thumbBtn.innerHTML = poster
          ? `
            <img src="${poster}" alt="${alt}" class="object-cover object-center w-full h-full block" />
            <span class="pointer-events-none absolute inset-0 flex items-center justify-center">
              <span class="w-8 h-8 rounded-full bg-white/80 flex items-center justify-center">
                <svg viewBox="0 0 20 20" class="w-4 h-4 fill-current text-black" aria-hidden="true">
                  <path d="M7 5.5v9l8-4.5-8-4.5z"></path>
                </svg>
              </span>
            </span>
            <span class="pdp-thumb-active-indicator pointer-events-none absolute inset-0 rounded-xl border-2 border-transparent"></span>
          `
          : `
            <div class="w-full h-full flex items-center justify-center text-xs text-black bg-white">Video</div>
            <span class="pdp-thumb-active-indicator pointer-events-none absolute inset-0 rounded-xl border-2 border-transparent"></span>
          `;
      }

      strip.appendChild(thumbBtn);
    });

    this.updateActiveThumb(0);
    return;
  }

  // ----- NEW TEMPLATE: grid, equal-width cells, no horizontal scroll -----
  strip.className = "pdp-thumb-strip pdp-thumb-grid mt-4";

  media.forEach((item, i) => {
    const thumbBtn = document.createElement("button");
    thumbBtn.type = "button";
    thumbBtn.className = "pdp-thumb-btn pdp-thumb-btn--grid";
    thumbBtn.dataset.index = i;

    // inner square frame for consistent rows (image + video)
    const frame = document.createElement("span");
    frame.className = "pdp-thumb-frame";

    if (!item || item.type === "image" || !item.type) {
      const src = item?.src375 ?? "";
      const alt = item?.alt ?? "";
      frame.innerHTML = `<img src="${src}" alt="${alt}" class="pdp-thumb-img" loading="lazy" />`;
    } else if (item.type === "video") {
      const poster = item.poster || "";
      const alt = item.alt || "Video";
      if (poster) {
        frame.innerHTML = `
          <img src="${poster}" alt="${alt}" class="pdp-thumb-img" loading="lazy" />
          <span class="pdp-thumb-play" aria-hidden="true">
            <span class="pdp-thumb-play__disc">
              <svg viewBox="0 0 20 20" class="pdp-thumb-play__icon" aria-hidden="true">
                <path d="M7 5.5v9l8-4.5-8-4.5z"></path>
              </svg>
            </span>
          </span>
        `;
      } else {
        frame.innerHTML = `<div class="pdp-thumb-fallback">Video</div>`;
      }
    }

    const indicator = document.createElement("span");
    indicator.className = "pdp-thumb-active-indicator";

    thumbBtn.appendChild(frame);
    thumbBtn.appendChild(indicator);
    strip.appendChild(thumbBtn);
  });

  this.updateActiveThumb(0);
}


  updateActiveThumb(activeIndex) {
    const allThumbs = this.querySelectorAll(".pdp-thumb-btn");
    allThumbs.forEach((btn) => {
      const ind = parseInt(btn.dataset.index, 10);
      const ringEl = btn.querySelector(".pdp-thumb-active-indicator");
      if (!ringEl) return;

      if (ind === activeIndex) {
        // selected thumb: show 2px solid black, same vibe as border-blk
        ringEl.style.borderColor = "#000000";
      } else {
        ringEl.style.borderColor = "transparent";
      }
    });
  }

  configureThumbs() {
    const strip = this.querySelector(".pdp-thumb-strip");
    if (!strip || !this.swiper) return;

    // click thumb -> go to that slide
    strip.addEventListener("click", (ev) => {
      const btn = ev.target.closest(".pdp-thumb-btn");
      if (!btn) return;
      const index = parseInt(btn.dataset.index, 10);
      if (isNaN(index)) return;
      this.swiper.slideTo(index);
    });

    // swiper change -> update active state and arrow vis
    this.swiper.on("slideChange", () => {
      const idx = this.swiper.realIndex;
      this.updateActiveThumb(idx);
      this.updateArrowVisibility();
    });
  }

  configureArrows() {
    if (!this.swiper) return;

    const prevBtn = this.querySelector(".pdp-swiper-prev");
    const nextBtn = this.querySelector(".pdp-swiper-next");

    if (prevBtn) {
      prevBtn.addEventListener("click", () => {
        // only move if we’re not already at first
        if (this.swiper.realIndex > 0) {
          this.swiper.slideTo(this.swiper.realIndex - 1);
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", () => {
        // only move if we’re not already at last
        const lastIndex = this.productImages.length - 1;
        if (this.swiper.realIndex < lastIndex) {
          this.swiper.slideTo(this.swiper.realIndex + 1);
        }
      });
    }

    // set initial visibility
    this.updateArrowVisibility();

    // also keep them synced on change
    this.swiper.on("slideChange", () => {
      this.updateArrowVisibility();
    });
  }

  updateArrowVisibility() {
    const prevBtn = this.querySelector(".pdp-swiper-prev");
    const nextBtn = this.querySelector(".pdp-swiper-next");
    if (!this.swiper || !prevBtn || !nextBtn) return;

    const idx = this.swiper.realIndex;
    const last = this.productImages.length - 1;

    // hide left arrow on first image
    if (idx === 0) {
      prevBtn.classList.add("invisible", "pointer-events-none");
    } else {
      prevBtn.classList.remove("invisible", "pointer-events-none");
    }

    // hide right arrow on last image
    if (idx === last) {
      nextBtn.classList.add("invisible", "pointer-events-none");
    } else {
      nextBtn.classList.remove("invisible", "pointer-events-none");
    }
  }


  renderBullets() {
    const images = this.productImages;
    const bulletsTarget = this.querySelector(
      ".gallery-target .carousel__pager-dots"
    );
    if (images.length < 2) return;
    for (const index in images) {
      const bullet = document.createElement("span");
      bullet.classList.add("carousel-pager");
      if (+index === 0) {
        bullet.classList.add("active");
      }
      bulletsTarget.appendChild(bullet);
    }
  }

  configureBullets() {
    const pagers = this.querySelectorAll(".carousel-pager");
    Array.from(pagers).forEach((pager, i) => {
      pager.addEventListener("click", () => {
        this.swiper.slideTo(i);
      });
    });

    this.swiper.on("slideChange", () => {
      pagers.forEach((el) => el.classList.remove("active"));
      const nextPager = pagers[this.swiper.realIndex];
      if (nextPager) nextPager.classList.add("active");
    });
  }
}

customElements.define("product-hero", ProductHero);

class ProductItem extends HTMLElement {
  connectedCallback() {
    this.swiper = null;
    this.swiperConfig = { loop: false };
    this.productTags = getWebEncodedComponentData(this, "productTags");
    this.imageOverride = getWebEncodedComponentData(this, "imageOverride");
    this.productVariantsInfo = getWebEncodedComponentData(
      this,
      "productVariantsInfo"
    );

    this.selectedVariantId = getWebEncodedComponentData(
      this,
      "defaultVariantId"
    );
    this.updateProductImages();
    this.addVariantPickerEvents();
    this.syncPurchaseButtonsForVariant(this.selectedVariant);
  }

  addVariantPickerEvents() {
    const pickers = Array.from(this.querySelectorAll(".variant-picker-js"));
    const anchorContainers = Array.from(
      this.querySelectorAll(".anchor-container-js")
    );

    for (const picker of pickers) {
      picker.addEventListener("click", () => {
        pickers.forEach((el) => el.classList.remove("bg-white"));
        picker.classList.add("bg-white");
        this.selectedVariantId = picker.dataset.variantId;
        anchorContainers.forEach((el) => (el.href = picker.dataset.variantUrl));
        this.updateProductImages();
      });
    }
  }

  updateProductImages() {
    const variantArr = this.productVariantsInfo[this.selectedVariantId];

    if (!variantArr) {
      this.productImages = this.productVariantsInfo.default
        ? this.productVariantsInfo.default.images
        : [];
    } else {
      this.productImages = variantArr.images.length
        ? this.productVariantsInfo[this.selectedVariantId].images
        : this.productVariantsInfo.default
        ? this.productVariantsInfo.default.images
        : [];
    }
    this.renderImages();
  }

  renderImages() {
    const images = this.productImages.slice(0, 2).reverse();
    const finalImages = this.imageOverride.image
      ? [images[0], this.imageOverride.image[0]]
      : images;
    const target = this.querySelector(".image-target-js");
    target.innerHTML = "";
    for (const imageIndex in finalImages) {
      const image = finalImages[imageIndex];
      const imageEl = createElementFromHTML(`
        <site-image class="${
          finalImages.length > 1 ? "product-item-image hover:opacity-0" : ""
        }">
          <div class="mediabox">
            <img
              src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
              alt="${image.alt}"
              height="${image.height}"
              width="${image.width}"
              class="lazyload ${image.additionalClass}"
              data-lowsrc="${image.src375}"
              data-sizes="${image.sizes}"
              data-srcset="${image.src375} 375w, ${image.src550} 550w, ${
        image.src750
      } 750w, ${image.src1100} 1100w, ${image.src1500} 1500w, ${
        image.src1780
      } 1780w" />
          </div>
        </site-image>
      `);
      target.appendChild(imageEl);
    }
  }
}

customElements.define("product-item", ProductItem);

class VariantImages extends HTMLElement {
  connectedCallback() {
    const renderVariantThumbs = (rowWidth) => {
      //console.log(rowWidth);
      const moreTagWidth = 56;
      const max = Math.floor((rowWidth - moreTagWidth) / 42);
      const buttons = Array.from(this.querySelectorAll('[role="button"]'));
      const moreLink = this.querySelector("a");

      buttons.forEach((button, i) => {
        button.classList.remove("hidden");
        if (i + 1 > max) {
          button.classList.add("hidden");
        }
      });
      if (max < buttons.length) {
        const p = moreLink.querySelector("p");
        moreLink.classList.remove("hidden");
        p.innerHTML = `+ ${buttons.length - max} more`;
      }
    };

    const rowWidth = this.getBoundingClientRect().width;
    renderVariantThumbs(rowWidth);

    window.addEventListener("resize", () => {
      const rowWidth = this.getBoundingClientRect().width;
      renderVariantThumbs(rowWidth);
    });
  }
}
customElements.define("variant-images", VariantImages);

(() => {
  // Track current path so we only rehydrate when navigating across products
  let lastPath = location.pathname;

  window.addEventListener("popstate", async () => {
    // If user navigates back/forward to a different product path
    if (location.pathname !== lastPath) {
      lastPath = location.pathname;
      try {
        const resp = await fetch(`${location.pathname}?view=ajax-hero`, { credentials: "same-origin" });
        if (!resp.ok) return;

        const html = await resp.text();
        const tmp = document.createElement("div");
        tmp.innerHTML = html.trim();

        const newHero = tmp.querySelector("product-hero");
        const currentHero = document.querySelector("product-hero");
        if (newHero && currentHero) currentHero.replaceWith(newHero);
        // newHero.connectedCallback() will run automatically
      } catch (e) {
        // If fetch fails, you can optionally hard-navigate:
        // location.reload();
      }
    }
  });
})();